// @flow
import React from "react";
import Link from "gatsby-link";
import styled from "styled-components";
import { Flex, Box, Container, Text, Link as RebassLink } from "rebass";
// import TiHeartFullOutline from "react-icons/lib/ti/heart-full-outline";

import { metaDataProps } from "../pages/index";
import FacebookButton from "./ui/FacebookButton";
import { navLinks } from "./Navbar";
import logoWhite from "../img/logo-white.png";
import Circle from "../components/ui/Circle";

const px = [1, 1, 3];
const py = [1, 1, 2];

const Footer = ({ siteMetadata }: metaDataProps) => (
  <StyledBar mx={[0]} py={[4, 4, 4, 5]} is="footer">
    <Container>
      <Flex wrap justify="center">
        <Box w={[1]} px={px} py={py} mb={[3]}>
          <LogoWrap>
            <img src={logoWhite} alt="Pipeline Logo" height="27" />
          </LogoWrap>
        </Box>

        <Box w={[1 / 2, 1 / 2, "auto"]} px={px} py={py}>
          <Link to="/">Home</Link>
        </Box>

        {navLinks.map((link, i) => (
          <Box w={[1 / 2, 1 / 2, "auto"]} px={px} py={py} key={i}>
            <Link to={link.path}>{link.label}</Link>
          </Box>
        ))}

        <Box w={[1, 1, "auto"]} px={px} py={py}>
          <Link to="/privacy">Privacy Policy</Link>
        </Box>

        <Box w={[1]} px={px} py={[0]} mt={[4]} className="text-center-desktop">
          <FacebookWrap>
            <RebassLink href={siteMetadata.appUrl}>
              <StyledFacebookButton mb={[2, 2, 3]}>
                Login with Facebook
              </StyledFacebookButton>
            </RebassLink>

            <FacebookCircle1 strokeColor="#fff" r={6} />
            <FacebookCircle2 strokeColor="#fff" r={3.5} />
            <FacebookCircle3 strokeColor="#fff" r={2.5} />
          </FacebookWrap>
        </Box>

        <Box w={[1]} px={px} py={[0]} mt={[0]} className="text-center-desktop">
          <Copyright>
            <CopyrightCircle strokeColor="#fff" r={2} />
            &copy; Pipeline Social {new Date().getFullYear()}
          </Copyright>
        </Box>

        {/* <Box w={[1]} px={px} py={[0]} mt={[0, 0, 1]}>
          <TagLine>
            p.s we <TiHeartFullOutline /> you
          </TagLine>
        </Box> */}
      </Flex>

      <Circle1 strokeColor="#fff" r={62} />
      <Circle2 strokeColor="#fff" r={100} />
      <Circle3 strokeColor="#fff" r={47} />
    </Container>
  </StyledBar>
);

export default Footer;

const StyledBar = styled(Box)`
  background: ${p => p.theme.colors.support4};
  box-shadow: inset 0 2px 18px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
  position: relative;
  z-index: 1;

  @media (min-width: 1025px) {
    text-align: center;
  }

  a {
    color: #fff;
    font-size: 14px;
    transition: all 300ms ease-in-out;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:visited {
      color: #fff;
    }
  }
`;

const LogoWrap = styled.div`
  @media (min-width: 48em) {
    text-align: center;
  }
`;

// const TagLine = styled.p`
//   color: palevioletred;
//   font-size: 12px;
//   margin: 0;

//   @media (min-width: 48em) {
//     text-align: center;
//   }
// `;

const Copyright = styled.div`
  color: #fff;
  display: inline-block;
  font-size: 12px;
  position: relative;
`;

const CopyrightCircle = styled(Circle)`
  left: -6px;
  opacity: 0.8;
  position: absolute;
  top: -7px;
`;

const FacebookWrap = styled.div`
  display: inline-block;
  position: relative;

  @media (min-width: 48em) {
    text-align: center;
  }
`;

const StyledFacebookButton = styled(FacebookButton)`
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.7);
  font-weight: 300;
  padding: 10px;
`;

const Circle1 = styled(Circle)`
  left: -90px;
  opacity: 0.3;
  position: absolute;
  top: -80px;

  @media (min-width: 48em) {
    left: 25%;
    top: -90px;
  }
`;

const Circle2 = styled(Circle)`
  right: -120px;
  opacity: 0.3;
  position: absolute;
  top: -80px;

  @media (min-width: 48em) {
    right: -60px;
    top: -130px;
  }
`;

const Circle3 = styled(Circle)`
  bottom: -85px;
  left: 25%;
  position: absolute;

  @media (min-width: 48em) {
    left: 40%;
  }
`;

const FacebookCircle1 = styled(Circle)`
  position: absolute;
  right: -18px;
  top: -15px;
`;

const FacebookCircle2 = styled(Circle)`
  position: absolute;
  right: -29px;
  top: -26px;
`;

const FacebookCircle3 = styled(Circle)`
  position: absolute;
  right: -39px;
  top: -33px;
`;



// WEBPACK FOOTER //
// ./src/components/Footer.jsx